import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

import { getColorVariable } from './constants'

function IconColoredAmplitudeM(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.545 4.294c-.211.278-.419.747-.569 1.423a1 1 0 0 1-1.952-.434c.183-.824.476-1.605.93-2.202C3.428 2.461 4.115 2 5 2c.364 0 .662.142.87.282.211.141.391.32.542.496.301.35.59.81.86 1.3.546.983 1.125 2.277 1.676 3.515.013.03.026.06.04.088.548 1.233 1.07 2.405 1.545 3.28.244.45.45.774.614.972l.013.015c.073-.046.168-.13.281-.286.23-.317.44-.807.589-1.405a1 1 0 0 1 1.94.486c-.184.735-.475 1.495-.911 2.095C12.62 13.44 11.939 14 11 14c-.374 0-.673-.154-.873-.294a2.74 2.74 0 0 1-.52-.498c-.29-.35-.569-.807-.832-1.294-.513-.944-1.063-2.18-1.595-3.374l-.059-.133c-.562-1.262-1.103-2.468-1.597-3.36-.25-.448-.46-.77-.63-.966a1.7 1.7 0 0 0-.046-.052c-.085.036-.185.11-.303.265Z"
        fill={getColorVariable('var(--color-typo-normal)')}
      />
      <path
        d="M2.5 7.5a.5.5 0 0 0 0 1v-1Zm3 1a.5.5 0 0 0 0-1v1Zm5-1a.5.5 0 0 0 0 1v-1Zm3 1a.5.5 0 0 0 0-1v1Zm-11 0h3v-1h-3v1Zm8 0h3v-1h-3v1Z"
        fill="var(--color-typo-primary)"
      />
    </svg>
  )
}
export const IconColoredAmplitude = createIcon({
  l: IconColoredAmplitudeM,
  m: IconColoredAmplitudeM,
  s: IconColoredAmplitudeM,
  xs: IconColoredAmplitudeM,
  name: 'IconColoredAmplitude',
})
